import { useCallback } from 'react'
import CertificationsService from '@/services/CertificationsService'
import ProjectsService from '@/services/ProjectsService'
import UserService2 from '@/services/UserService2'

export default function useProjectsApi() {
	const getAllProjects = useCallback(options => ProjectsService.getAll(options), [])
	const searchProjects = useCallback((searchText, options) => ProjectsService.search(searchText, options), [])
	const getProjectById = useCallback(id => ProjectsService.getById(id), [])
	const createProject = useCallback(payload => ProjectsService.create(payload), [])
	const updateProject = useCallback((id, payload) => ProjectsService.update(id, payload), [])
	const deleteProject = useCallback(id => ProjectsService.delete(id), [])
	const uploadProjectFile = useCallback(
		(projectId, file, onUploadProgress) => ProjectsService.uploadProjectFile(projectId, file, onUploadProgress),
		[]
	)
	const downloadProjectFile = useCallback(
		(projectId, fileUuid) => ProjectsService.downloadProjectFile(projectId, fileUuid),
		[]
	)
	const deleteProjectFile = useCallback(
		(projectId, fileUuid) => ProjectsService.deleteProjectFile(projectId, fileUuid),
		[]
	)
	const getAllCertifications = useCallback(options => CertificationsService.getAll(options), [])
	const getContentOptions = useCallback(() => ProjectsService.getContentOptions(), [])
	const getTrainersForTraining = useCallback(options => UserService2.getTrainersForTraining(options), [])

	return {
		createProject,
		deleteProject,
		getAllCertifications,
		getTrainersForTraining,
		getContentOptions,
		getAllProjects,
		getProjectById,
		searchProjects,
		uploadProjectFile,
		downloadProjectFile,
		deleteProjectFile,
		updateProject,
	}
}
